import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import MapSelection from './../../sig/MapSelect/container/MapSelection';

class MapView extends Component {
  dataMapComunes = (dataComunes, a) => {
    //console.log('dataComunes',dataComunes)
    this.props.dataMapComunes(dataComunes, a);
  }

  dataMapCuadrates = (dataCuadrante, a) => {
    this.props.dataMapCuadrantes(dataCuadrante, a)
  }

  dataMapNeigborhoods = (dataNeigborhoods) => {
    // console.log('dataNeigborhoods',dataNeigborhoods)
    this.props.dataMapNeigborhoods(dataNeigborhoods);
  }

  getListSearch = () => {

    let data = this.props.dataLocation;
    let object = [];
    try {
      if (Object.getOwnPropertyNames(data).length > 0) {
        data.municipio.map((place) => {
          object.push({ label: place.value + ' (MU)', value: '{"id":' + place.id + ',"object":"municipio_id","zone":"mun"}' });
          return null;
        })
        data.comuna.map((place) => {
          object.push({ label: place.value + ' (CO)', value: '{"id":' + place.id + ',"object":"comuna_id","zone":"com"}' });
          return null;
        })
        data.barrio.map((place) => {
          if (place.value !== 'Galicia')
            object.push({ label: place.value + ' (BA)', value: '{"id":' + place.id + ',"object":"barrio_id","zone":"urb"}' });
          return null;
        })
        data.urbanizacion.map((place) => {
          object.push({ label: place.value + ' (UR)', value: '{"id":' + place.id + ',"object":"id","zone":""}' });
          return null;
        })
        return object
      }

    } catch (error) {

    }
    // return [
    //     { label: '1 Liborio Mejia', value: 'Comuna 1' }
    // ].map((suggestion, i) => ({
    //     value: suggestion.value,
    //     label: suggestion.label,
    // }));

  }


  render() {
    const { dataResult } = this.props;

    return (

      <Grid id="ContenedorMap" item xs={12}>
        {
          typeof this.props.dataList == ! "undefined" ? null :
            <MapSelection
              data={dataResult}
              searchData={this.getListSearch()}
              dataMapNeigborhoods={this.dataMapNeigborhoods}
              dataMapComunes={this.dataMapComunes}
              setCuadrante={this.dataMapCuadrates}
              dataList={this.props.dataLocation}
              locationObject={this.props.locationObject}
              prueba={this.getListSearch()}
              fromMap={this.props.fromMap}
              sendPolygon={this.props.sendPolygon}
            />
        }

      </Grid>

    )
  }
}


export default MapView;
